import { render, staticRenderFns } from "./Slick.vue?vue&type=template&id=1d94d48c&scoped=true&"
import script from "./Slick.vue?vue&type=script&lang=js&"
export * from "./Slick.vue?vue&type=script&lang=js&"
import style0 from "./Slick.vue?vue&type=style&index=0&id=1d94d48c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d94d48c",
  null
  
)

export default component.exports